import { getOrganizationSnapshot, subscribeOrganizationContext } from './organizationContext'

export function getCurrentOrganizationId(fallback = null) {
  return getOrganizationSnapshot().orgId ?? fallback
}

export function bindOrganizationContext(component, listener) {
  cleanupOrganizationContext(component)
  component.unsubscribeOrganizationContext = subscribeOrganizationContext((state) => listener.call(component, state))

  return component.unsubscribeOrganizationContext
}

export function cleanupOrganizationContext(component) {
  component.unsubscribeOrganizationContext?.()
  component.unsubscribeOrganizationContext = null
}
